import React from 'react';
import styled from '@emotion/styled';
import MUISlider from '@mui/material/Slider';

const StyledMuiSlider = styled(MUISlider)`
  .MuiSlider-thumbColorPrimary.MuiSlider-thumbColorPrimary {
    background-color: ${({ theme }) => theme.colors?.primary};
  }
  .MuiSlider-valueLabel {
    background: transparent;
    transform: none;
  }
  .MuiSlider-valueLabel > span {
    background-color: transparent;
    transform: none;
  }
  .MuiSlider-valueLabel > span > span {
    color: ${({ theme }) => theme.colors?.black};
    top: 12px;
    position: relative;
    font-size: 0.95rem;
    font-family: ${({ theme }) => theme.fonts?.secondary};
    transform: none;
  }
  .MuiSlider-rail.MuiSlider-rail {
    background-color: hsl(339, 73%, 72%);
  }
  .MuiSlider-track.MuiSlider-track {
    background-color: ${({ theme }) => theme.colors?.primary};
  }
`;

const Slider = (properties) => (
  <StyledMuiSlider {...properties} />
);

export default Slider;
